<template>
  <div id="app">
    <meta name="viewport"
          content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no">
    <meta name="apple-mobile-web-app-capable"
          content="yes">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  watch: {
 $route: {
  immediate: true,
  deep: true,
  handler(to) {
   // 微信浏览器判断
  //  const WECHAT_BROWSER = navigator.userAgent.toLowerCase().includes('micromessenger')
 
  //  // 解决iOS微信浏览器分享地址只能是落地页的问题，这个操作是不会刷新页面的，query参数改变也会执行
  //  if (WECHAT_BROWSER) {
    // eslint-disable-next-line
    console.log('微信浏览器判断',to,   window.location.href )
    window.location.href = window.location.href
  //  }
  }
}
}}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue